// extracted by mini-css-extract-plugin
export default {"font-renta":"Employees_font-renta__6oJ6c"};